export default __webpack_public_path__ + "static/media/ic-attempted.af6332e6.svg";